import { render, staticRenderFns } from "./vSupplier.vue?vue&type=template&id=90d693bc&"
import script from "./vSupplier.vue?vue&type=script&lang=js&"
export * from "./vSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports